module.exports = __webpack_public_path__ + "static/ocorie-abt-4-d4c3a578d00d6dc60df9f4fb9fe03948.png";